<template>
  <div>
    <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit">
      <b-row class="toolbar-ptc">
        <b-col>
          <router-link :to="{ name: 'combo_list', params: { search: search } }" class="btn btn-ptc1" tag="button">返回</router-link>
        </b-col>
        <b-col class="text-center title">線上點餐管理 / 套餐管理 / 新增</b-col>
        <b-col>
          <div class="text-right">
            <button type="submit" class="btn btn-save" @click="save">儲存</button>
            <button type="button" class="btn btn-clear" @click="clear">清除</button>
          </div>
        </b-col>
      </b-row>

      <div id="func-content">
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-7">
              <div class='row mb-3'>
                <label class='control-label col-md-3'>餐點名稱：</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='title' placeholder='請輸入餐點名稱' maxlength="30" required>
                  <div class="text-danger" v-if="valid_title&&!title">{{valid_title}}</div>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>販售週期：</label>
                <div class='col-md-7'>
                  <b-form-group>
                    <b-form-checkbox-group id="checkbox-group-1" v-model="week" :options="optionsWeek" name="flavour-1" ></b-form-checkbox-group>
                  </b-form-group>
                  <div class="text-danger" v-show="this.valid_WeekMsg != ''">{{this.valid_WeekMsg}}</div>
                </div>
              </div>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>販售對象：</label>
                <div class='col-md-7'>
                  <input type='radio' name='rdoGroup' value=1 v-model='MemberType'>
                    <label for='MemberType1'>全部會員</label>
                  <input type='radio' name='rdoGroup' value=2 v-model='MemberType'>
                    <label for='MemberType2'>正式會員</label>
                </div>
              </div>

              <div class='row mb-3'>
                <label class='control-label col-md-3'>備註：</label>
                <div class='col-md-7'>
                  <input type='text' name='Input_Memo' class='form-control' v-model.trim='memo' placeholder='請輸入備註' maxlength="30" >
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="control-label">圖片上傳</label>
                  <input type="file" class="upload_input" id="pic" ref="inputer" accept="image/*" multiple @change="handleFileChange">
                  <label class="upload_block" for="pic">
                    <span class="upload_icon">➕</span>
                    <img class="upload_img" v-if="img_url != undefined" :src="img_url">
                  </label>
                  <br />
                  <!-- <div class="text-danger" v-if="valid_img_url">{{valid_img_url}}</div> -->
                  <span class="text-danger">※限制上傳一張圖片，建議尺寸為800x600</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class='col-lg-7'>
              <div class='row mb-3'>
                <label class='control-label col-md-3'>套餐品項：</label>
                <div class='col-md-7'>
                  <button type="button" class="btn btn-save" @click="addOption" v-if="this.lists.length<=1" style="visibility:hidden">新增選項</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5">
          </div>
          <template>
  <div role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-0 variant="info">主餐</b-button>
      </b-card-header>
      <b-collapse id="accordion-0" visible role="tabpanel">
        <b-card-body>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>折扣金額：</label>
                <div class='col-md-7'>
                  <validate>
                    <input type='number' class='form-control' v-model.trim='Discount' name="Input_Discount" placeholder='請輸入折扣金額' maxlength="5" min="0" required>
                    <field-messages name="Input_Discount" show="$invalid && $submitted" class="text-danger">
                      <div v-if='this.valid_discount == ""' slot="required">折扣金額為必輸</div>
                    </field-messages>
                    <div class="text-danger" v-if="valid_discount">{{valid_discount}}</div>
                  </validate>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>品項：</label>
                <div class='col-md-7'>
                  <multiselect v-model="MainProduct" :options="products" :multiple="false" :custom-label="nameWithLang" group-values="Detail" group-label="Attribute" :group-select="false" placeholder="請選擇" track-by="Name" label="Name" selectLabel="">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                  <div class="text-danger" v-if="valid_MainProduct&&!MainProduct">{{valid_MainProduct}}</div>
                </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <div v-for="(list,index) in lists" :key="index">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle="'accordion-'+index+1" variant="info">搭配{{index+1}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+index+1" visible role="tabpanel">
        <b-card-body>
          <div class='row mb-3'>
            <div class='col-md-12'>
              <button type="button" class="btn btn-clear" @click="delOption(index)" style="float:right" v-if="index>0">删除搭配{{index+1}}</button>
            </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>APP顯示文字：</label>
                <div class='col-md-7'>
                  <input type='text' class='form-control' v-model.trim='list.AppShowWord' placeholder='請輸入APP顯示文字' maxlength="30" >
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>折扣金額：</label>
                <div class='col-md-3'>
                  <div v-if="!list.IsRequired">
                    <validate>
                      <input type='number' class='form-control' v-model.trim='list.Discount1' :name="'Input_Discount1-'+index" placeholder='請輸入折扣金額' maxlength="5" min="0" required>
                        <field-messages show="$invalid && $submitted" class="text-danger">
                          <div v-if='list.valid_Discount1 == ""' slot="required">折扣金額為必輸</div>
                        </field-messages>
                        <div class="text-danger" v-if="list.valid_Discount1">{{list.valid_Discount1}}</div>
                    </validate>
                  </div>
                </div>
                <div class='col-md-1'>
                </div>
                <label class='control-label col-md-2'>是否必選：</label>
                <div class='col-md-3'>
                  <toggle-button v-model="list.IsRequired" :width=60 :height=30 :sync="true" style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}" />
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>搭配型態：</label>
                <div class='col-md-7'>
                  <input type='radio' :name="('rdoType'+index)" value='2' v-model='list.OptionType'>
                    <label for='OptionType1'>POS分類</label>
                  <input type='radio' :name="('rdoType'+index)" value='1' v-model='list.OptionType'>
                    <label for='OptionType2'>單品</label>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>更換商品：</label>
                <div class='col-md-7'>
                  <multiselect v-model="list.OptionProduct2" :options="productAttributes" :multiple="true" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" v-if="list.OptionType=='2'" :close-on-select="false" selectLabel=""></multiselect>
                  <div class="text-danger" v-if="list.valid_OptionProduct2&&list.OptionType=='2'">{{list.valid_OptionProduct2}}</div>
                  <multiselect v-model="list.OptionProduct1" :options="products2" :multiple="true" :custom-label="nameWithLang" group-values="Detail" group-label="Attribute" :group-select="true" placeholder="請選擇" track-by="Name" label="Name" v-if="list.OptionType=='1'" :close-on-select="false" selectLabel="">
                    <span slot="noResult">查無資料</span>
                  </multiselect>
                  <div class="text-danger" v-if="list.valid_OptionProduct1&&list.OptionType=='1'">{{list.valid_OptionProduct1}}</div>
                </div>
          </div>
          <div class='row mb-3'>
                <label class='control-label col-md-3'>預設商品：</label>
                <div class='col-md-7'>
                  <div v-if="list.IsRequired">
                  <multiselect v-model="list.DefaultProduct" :options="list.DefProducts" :multiple="false" :custom-label="nameWithLang" placeholder="請選擇" label="name" track-by="name" @open="getDefProducts(index)" selectLabel=""></multiselect>
                  <div class="text-danger" v-if="list.valid_DefaultProduct&&!list.DefaultProduct">{{list.valid_DefaultProduct}}</div>
                  </div>
                </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    </div>
  </div>
          </template>
        </b-card>

        <!-- Double Check Modal -->
        <b-modal ref="mdCheck" hide-footer title="套餐變更">
          <b-container fluid>
            <form>
              <div class="row mb-3">
                <label class="control-label">確定新增此套餐 ?</label>
              </div>
              <div class="float-right">
                <b-btn variant="primary" @click="confirm">確定</b-btn>
                <b-btn variant="secondary" @click="cancel">取消</b-btn>
              </div>
            </form>
          </b-container>
        </b-modal>

      </div>
    </vue-form>
  </div>
</template>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL, fileUploadMaxSize} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
miniToastr.init()
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      formstate: {}, // 驗證用
      title: '',
      MemberType: 1,
      memo: '',
      img_url: undefined,
      Discount: '0',
      valid_errMsg: false,
      valid_title: '',
      valid_img_url: '',
      valid_WeekMsg: '',
      valid_discount: '',
      valid_MainProduct: '',
      search: {}, // 記錄查詢條件
      FunctionPermission: 0,
      week: [0, 1, 2, 3, 4, 5, 6],
      optionsWeek: [
        { text: '一', value: 1 },
        { text: '二', value: 2 },
        { text: '三', value: 3 },
        { text: '四', value: 4 },
        { text: '五', value: 5 },
        { text: '六', value: 6 },
        { text: '日', value: 0 }
      ],
      products: [], // 商品清單不含group
      products2: [], // 商品清單含group
      MainProduct: '',
      productAttributes: [],
      lists: [{
        AppShowWord: '',
        Discount1: '0',
        IsRequired: false,
        OptionType: '2',
        OptionProduct: [],
        OptionProduct1: [],
        OptionProduct2: [],
        DefProducts: [], // user選擇搭配的商品清單
        DefaultProduct: '',
        valid_Discount1: '',
        valid_OptionProduct1: '',
        valid_OptionProduct2: '',
        valid_DefaultProduct: ''
      }]
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F17') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    } else if (this.FunctionPermission < 2) {
      this.$router.push({ name: 'combo_list' })
      return
    }

    var search = this.$route.params.search
    if (search !== undefined) {
      this.search = search
    }
    this.getAllProducts()
    this.getAllProducts2()
    this.getAllProductAttributes()
  },
  props: {
    value: {
      default: undefined
    }
  },
  methods: {
    onSelect (option) {
      console.log('onSelect')
    },
    onTouch () {
      console.log('onTouch')
    },
    addOption () {
      let cope = {
        AppShowWord: '',
        Discount1: '0',
        IsRequired: false,
        OptionType: '2',
        OptionProduct: [],
        OptionProduct1: [],
        OptionProduct2: [],
        DefProducts: [],
        DefaultProduct: '',
        valid_Discount1: '',
        valid_OptionProduct1: '',
        valid_OptionProduct2: '',
        valid_DefaultProduct: ''
      }
      this.lists.push(cope)
      // console.log(this.lists.length)
    },
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    delOption (index) {
      this.lists.splice(index, 1)
      console.log(this.lists)
    },
    // 取得商品類別與明細(不含group)
    getAllProducts () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 1,
        hasDelete: false,
        hasExtra: false,
        hasCombo: false
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.products = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    // 取得商品類別與明細(含group)
    getAllProducts2 () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproducts/v1', {
        status: 2,
        hasDelete: false,
        hasExtra: true,
        hasCombo: false
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.products2 = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    getAllProductAttributes () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getallproductAttributes/v1', {
        status: 1
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.productAttributes = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    // user所選搭配的商品列表
    getDefProducts (index) {
      this.$parent.Loading = true
      console.log(this.lists[index].DefaultProduct)
      var option = []
      if (this.lists[index].OptionType === '1') {
        option = this.lists[index].OptionProduct1
      } else {
        option = this.lists[index].OptionProduct2
      }
      return axios.post(API_URL + '/web/shopping/getDefProducts/v1', {
        OptionProduct: option
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            // var a = this.lists[index].DefaultProduct
            this.lists[index].DefaultProduct = ''
            console.log(this.lists[index].DefaultProduct)
            this.lists[index].DefProducts = response.data.data
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    clear () {
      const input = this.$refs.inputer
      input.type = 'text'
      input.type = 'file'

      this.title = ''
      this.img_url = undefined
      this.Discount = '0'
      this.MainProduct = ''
      this.week = [0, 1, 2, 3, 4, 5, 6]
      this.MemberType = 1
      this.memo = ''

      this.valid_errMsg = false
      this.valid_title = ''
      this.valid_img_url = ''
      this.valid_WeekMsg = ''
      this.valid_discount = ''
      this.valid_MainProduct = ''

      this.lists = [{
        AppShowWord: '',
        Discount1: '0',
        IsRequired: false,
        OptionType: '2',
        OptionProduct: [],
        OptionProduct1: [],
        OptionProduct2: [],
        DefProducts: [],
        DefaultProduct: '',
        valid_Discount1: '',
        valid_OptionProduct1: '',
        valid_OptionProduct2: '',
        valid_DefaultProduct: ''
      }]
    },
    save () {
      this.valid_errMsg = false
      for (var p in this.lists) {
        if (this.lists[p].OptionType === '1') {
          this.lists[p].OptionProduct = this.lists[p].OptionProduct1

          if (this.lists[p].OptionProduct1 === undefined || this.lists[p].OptionProduct1 === null) {
            this.valid_errMsg = true
            this.lists[p].valid_OptionProduct1 = 'POS類別為必選'
          } else {
            this.lists[p].valid_OptionProduct1 = ''
          }
          this.lists[p].valid_OptionProduct2 = ''
        } else {
          this.lists[p].OptionProduct = this.lists[p].OptionProduct2

          if (this.lists[p].OptionProduct2 === undefined || this.lists[p].OptionProduct2 === null) {
            this.valid_errMsg = true
            this.lists[p].valid_OptionProduct2 = 'POS類別為必選'
          } else {
            this.lists[p].valid_OptionProduct2 = ''
          }
          this.lists[p].valid_OptionProduct1 = ''
        }

        if (this.lists[p].IsRequired) {
          if (!this.lists[p].DefaultProduct.Code) {
            this.valid_errMsg = true
            this.lists[p].valid_DefaultProduct = '預設商品為必選'
          } else {
            this.lists[p].valid_DefaultProduct = ''
          }
        } else {
          if (!this.lists[p].Discount1) {
            this.valid_errMsg = true
            this.lists[p].valid_Discount1 = ''
          } else if (Number(this.lists[p].Discount1) < 0) {
            this.valid_errMsg = true
            this.lists[p].valid_Discount1 = '折扣金額不可小於0'
          } else {
            this.lists[p].valid_Discount1 = ''
          }
        }
      }

      if (!this.title) {
        this.valid_errMsg = true
        this.valid_title = '標題為必填'
      }
      // if (!this.img_url) {
      //   this.valid_errMsg = true
      //   this.valid_img_url = '圖片為必選'
      // }
      if (!this.week || this.week.length <= 0) {
        this.valid_errMsg = true
        this.valid_WeekMsg = '請至少勾選一個週期'
      } else {
        this.valid_WeekMsg = ''
      }
      if (!this.Discount) {
        this.valid_errMsg = true
        this.valid_discount = ''
        // this.valid_discount = '折扣金額為必填'
      } else if (Number(this.Discount) < 0) {
        this.valid_errMsg = true
        this.valid_discount = '折扣金額不可小於0'
      } else {
        this.valid_discount = ''
      }

      if (!this.MainProduct.Code) {
        this.valid_errMsg = true
        this.valid_MainProduct = '品項為必選'
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      this.$refs.mdCheck.show()
    },
    cancel () {
      this.$refs.mdCheck.hide()
    },
    confirm () {
      this.$refs.mdCheck.hide()
      this.$parent.Loading = true
      for (var p in this.lists) {
        if (this.lists[p].IsRequired) {
          this.lists[p].Discount = '0'
        } else {
          this.lists[p].DefaultProduct = JSON.parse('{"Code":"", "Name":"", "ItemType":0 }')
        }
      }
      var arrAll = {
        name: this.title,
        memo: this.memo,
        MemberType: Number(this.MemberType),
        week: this.week.toString(),
        MainDiscount: Number(this.Discount),
        MainProductCode: this.MainProduct.Code,
        lists: this.lists
      }
      let formData = new FormData()
      formData.append('image', this.file)
      formData.append('data', JSON.stringify(arrAll))

      var config = {
        headers: {
          'Content-Type': undefined
        }
      }
      return axios.post(API_URL + '/web/shopping/createcombo/v1',
        formData, config
      )
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('套餐已新增')
            this.$router.push({ name: 'combo_list', params: { search: this.search } })
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增失敗')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料新增失敗')
          console.log(error)
        })
    },
    handleFileChange (e) {
      this.valid_img_url = ''
      let inputDOM = this.$refs.inputer
      this.file = inputDOM.files[0]
      this.$emit('input', this.file)
      if (!this.imgPreview(this.file)) {
        this.$refs.inputer.value = ''
        this.img_url = undefined
      }
    },
    imgPreview (file) {
      var rtn = false
      let self = this
      if (!file || !window.FileReader) return
      if (/^image/.test(file.type)) {
        if (file.size > fileUploadMaxSize) {
          miniToastr.error('圖檔大小不可超過 5MB')
        } else {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onloadend = function () {
            self.img_url = this.result
          }
          rtn = true
        }
      } else {
        miniToastr.error('請選擇正確圖檔')
      }
      return rtn
    }
  }
}
</script>
<style scoped>
.upload_block {
  position: relative;
  width: 257px;
  height: 220px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 40%;
}
.block {
  height: 454pt;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/combo/Add.vue